// AI stage output contracts — API §3.2–3.5. These schemas are what generateObject enforces.
import { z } from 'zod';
import { layoutHint } from './edition.js';

export const themeSuggestionsOutput = z.object({
  suggestions: z
    .array(z.object({ title: z.string().max(60), description: z.string().max(200) }))
    .min(3)
    .max(3),
});
export type ThemeSuggestionsOutput = z.infer<typeof themeSuggestionsOutput>;

export const promptsOutput = z.object({
  prompts: z.array(z.string().max(200)).min(3).max(5),
});
export type PromptsOutput = z.infer<typeof promptsOutput>;

export const storyOutput = z.object({
  narrative: z.string(),
  suggested_layout: layoutHint,
});
export type StoryOutput = z.infer<typeof storyOutput>;

export const puzzleCluesOutput = z.object({
  clues: z.array(z.object({ answer: z.string(), clue: z.string().max(120) })),
});
export type PuzzleCluesOutput = z.infer<typeof puzzleCluesOutput>;

export const horoscopeOutput = z.object({
  horoscopes: z.array(
    z.object({ member_name: z.string(), zodiac: z.string(), text: z.string().max(400) }),
  ),
});
export type HoroscopeOutput = z.infer<typeof horoscopeOutput>;

export const foodOutput = z.object({
  recipe: z.object({
    title: z.string(),
    description: z.string().max(300),
    prep_time: z.string(),
    ingredients: z.array(z.string()).min(2),
    steps: z.array(z.string()).min(2),
    dietary_note: z.string(),
  }),
});
export type FoodOutput = z.infer<typeof foodOutput>;

export const travelOutput = z.object({
  destination: z.object({
    name: z.string(),
    country: z.string(),
    why_your_family_would_love_it: z.string().max(700),
    fun_fact: z.string().max(300),
  }),
});
export type TravelOutput = z.infer<typeof travelOutput>;

export const photoCollectionOutput = z.object({
  collection_title: z.string().max(80),
  selected_photos: z.array(
    z.object({
      photo_id: z.string(),
      caption: z.string().max(140),
      alt_text: z.string().max(200),
      display_order: z.number().int(),
    }),
  ),
});
export type PhotoCollectionOutput = z.infer<typeof photoCollectionOutput>;

export const occasionCardsOutput = z.object({
  cards: z.array(
    z.object({
      recipient_name: z.string(),
      occasion_type: z.string(),
      message: z.string().max(220),
      design_hint: z.string(),
    }),
  ),
});
export type OccasionCardsOutput = z.infer<typeof occasionCardsOutput>;
